import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Skeleton } from "../components/ui/Skeleton";
import { CommunityEmptyState } from "../features/community/CommunityEmptyState";
import { FeedItem } from "../features/community/FeedItem";
import { StatusPicker } from "../features/community/StatusPicker";
import { useCommunityFeed } from "../features/community/hooks";

export function CommunityRoute() {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useCommunityFeed(30);
  const [pickerStation, setPickerStation] = useState<{ id: string; name: string } | null>(null);

  return (
    <div className="space-y-4 pt-3 md:max-w-2xl">
      <header>
        <h1 className="text-2xl font-bold tracking-tight text-fg">{t("community.title")}</h1>
        <p className="text-sm text-fg-mute">{t("community.subtitle")}</p>
      </header>

      {pickerStation && (
        <StatusPicker
          stationId={pickerStation.id}
          stationName={pickerStation.name}
          onClose={() => setPickerStation(null)}
        />
      )}

      {isLoading && (
        <ul className="space-y-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <li key={i}>
              <Skeleton className="h-16 w-full" />
            </li>
          ))}
        </ul>
      )}

      {isError && <p className="text-sm text-ember">{t("community.feed_failed")}</p>}

      {!isLoading && !isError && (!data || data.length === 0) && <CommunityEmptyState />}

      {!isLoading && data && data.length > 0 && (
        <ul className="space-y-2">
          {data.map((event) => (
            <FeedItem
              key={event.event_id}
              event={event}
              onReportIssue={() =>
                setPickerStation({ id: event.station_id, name: event.station_name })
              }
            />
          ))}
        </ul>
      )}
    </div>
  );
}
